<div
  class="app-multi-select f-control"
  [ngClass]="{ 'with-label': !!label, 'app-multi-select--disabled': control.disabled }"
>
  @if (label) {
    <div class="label">
      {{ label }}:
      <ng-container *ngIf="isRequired">*</ng-container>
    </div>
  }

  <mat-form-field
    appearance="outline"
    class="field"
    [ngClass]="{ 'mat-form-field-invalid': control.invalid && control.touched }"
  >
    <mat-chip-grid #chipGrid>
      @for (value of selectedOptionValues; track value) {
        <!-- <span class="selected-option-value" (click)="remove(value)">{{ getLabel(value) }} <mat-icon>close</mat-icon></span> -->
        <mat-chip-row [disabled]="control.disabled" (removed)="remove(value)">
          {{ getLabel(value) }}
          <button matChipRemove [disabled]="control.disabled">
            <mat-icon>close</mat-icon>
          </button>
        </mat-chip-row>
      }
    </mat-chip-grid>
    <input
      class="input-field"
      [placeholder]="control.disabled ? '' : (placeholderKey | transloco)"
      #optionInput
      [formControl]="control"
      [matChipInputFor]="chipGrid"
      [matAutocomplete]="auto"
      [readonly]="control.disabled"
    />
    <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selected($event)">
      @for (option of filteredOptions$ | async; track option) {
        <mat-option
          [value]="option[this.optionValue]"
          class="autocomplete-option"
          [ngClass]="{
            'd-none': isHiddenOption(option[this.optionValue])
          }"
          >{{ option[this.optionLabel] }}</mat-option
        >
      }
    </mat-autocomplete>
  </mat-form-field>

  <mat-error class="errors" *ngIf="control.invalid && control.touched">
    {{ getErrorMessage() }}
  </mat-error>
</div>
